// extracted by mini-css-extract-plugin
export default {"radioGroup":"CxSX5ZaRlAzq6c4labWP","transactionFeesGroup":"HwSVydD3iEzp90ZZyZCb","customFeeInputGroup":"XbcFPEiq3d3zyv19aj3J","customFeeInput":"sNE7Kq7JLbXp63hlzPpA"};